import { html } from "../../../../../jb-nexus/node_modules/lit";
import { NexusComponent } from "./nexus.component";

// Helpers
const cleanPath = (path) => {
  // Remove double slashes, but preserve root slash
  return path.replace(/\/{2,}/g, "/").replace(/\/$/, "") || "/";
}

// Main component
export class LanguageSwitcher extends NexusComponent {
  constructor() {
    super();
  }

  get languagesContainer() {
    return this.querySelector(".language-switcher-langs");
  }

  get languages() {
    return this.querySelectorAll(".language-switcher-lang");
  }

  get activeLanguageCode() {
    const lang = document.querySelector("html").getAttribute("lang");
    if (!lang) return "nl";
    
    return lang.split("-")[0]; // Parse short country code from lang attribute: nl-NL -> nl, en-US -> en
  }

  get activeLanguage() {
    return Array.from(this.languages).find(
      (language) => language.dataset.lang === this.activeLanguageCode
    );
  }

  get isEnglishDefault() {
    return window.location.pathname === "/" && this.activeLanguageCode === "en";
  }

  get isDutchDefault() {
    return window.location.pathname === "/" && this.activeLanguageCode === "nl";
  }

  get defaultLanguage() {
    // If we are on root
    if (this.isEnglishDefault) return "en";
    if (this.isDutchDefault) return "nl";

    // If we are on a specific language path
    const currentPath = window.location.pathname;
    if (currentPath.startsWith("/en/")) {
      return "nl";
    } else if (currentPath.startsWith("/nl/")) {
      return "en";
    }

    // Fallback
    return "nl";
  }

  connectedCallback() {
    super.connectedCallback();

    this.setActiveLangauge();
    this.addEventListener("click", this.handleLanguageSwitch);
  }

  setActiveLangauge() {
    this.activeLanguage.classList.add("fw-bold");
  }

  handleLanguageSwitch(event) {
    event.preventDefault();
    window.location.href = this.getNewUrl();
  }

  getNewUrl() {
    const currentPath = window.location.pathname;
    const currentLang = this.activeLanguageCode; // e.g. 'en'
    const targetLang = currentLang === "en" ? "nl" : "en";
    const defaultLang = "en";

    function stripLangPrefix(path, lang) {
      const langPrefix = `/${lang}/`;
      if (path.startsWith(langPrefix)) {
        return "/" + path.slice(langPrefix.length);
      }
      if (path === `/${lang}`) return "/";
      return path;
    }

    let newPath = currentPath;

    // If currently on a language-prefixed path, strip it if switching to default
    if (
      (currentPath.startsWith(`/${currentLang}/`) ||
        currentPath === `/${currentLang}`) &&
      targetLang === defaultLang
    ) {
      newPath = stripLangPrefix(currentPath, currentLang);
      return `${window.location.origin}${cleanPath(newPath)}${
        window.location.search
      }${window.location.hash}`;
    }

    // If switching to non-default language, ensure prefix is added (unless already there)
    if (targetLang !== defaultLang) {
      if (currentPath.startsWith(`/${targetLang}/`) || currentPath === `/${targetLang}`) {
        return `${window.location.origin}${cleanPath(currentPath)}${window.location.search}${window.location.hash}`;
      }

      newPath = stripLangPrefix(currentPath, currentLang);
      
      return `${window.location.origin}/${targetLang}${cleanPath(newPath)}${
        window.location.search
      }${window.location.hash}`;
    }

    // If switching to default lang from a path that is already default (e.g. `/`), just reload
    return `${window.location.origin}${cleanPath(currentPath)}${window.location.search}${window.location.hash}`;
  }

  render() {
    return html` <slot></slot> `;
  }
}

customElements.define("language-switcher", LanguageSwitcher);